export default {
    linkList : {
        "companyLink": "会社紹介",
        "termsOfService": "利用規約",
        "privacyPolicy": "プライバシーポリシー",
        "guaranteeOfRights": "データ主体の権利",
        "operationPolicy": "運営ポリシー",
        "communityPolicy": "コミュニティポリシー",
        "youthProtectionPolicy": "青少年保護政策",
        "declarationOfSafety": "安心・安全宣言",
        "cookiePolicy": "クッキーポリシー",
        "customerSupport": "お問い合わせ",
        "doNotSell": "Do Not Sell My Personal Information",
        "gameGrade": "게임이용등급",
        "communityPolicyView": "コミュニティ運営ポリシー",
        "servicePolicy": "서비스정책",
        "termsOfUse": "회원정책",
        "operationPolicyNCJ": "運営方針",
    },
    footerWords:{
        "gameRelatedLaw": "ゲーム関連法律に基づく追加表記",
        "brandInformation": "商号情報",
        "copyright": "著作権情報",
        "channelingInfo": "㈱NCSOFTはplaync内チャネリングサービスの提供を仲介する通信販売仲介業者であり、通信販売の当事者ではありません。<br>チャンリングサービスの提供に関連したすべての義務と責任は個別の通信販売事業者にあり、これに関連して発生した問題に対して、当社は責任を負いません。"
    },
    infoCS:{
        "businessInformation": "事業者情報確認",
        "infoAddress": "事業者名 ㈱NCSOFT 代表 キム・テクジン 事業者登録番号 144-85-04244 通信販売業申告 第2013-京義城南-1268号",
        "mobile": "住所 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea お客様相談室 +82-1566-7004 FAX +82-2-2186-3499",
        "pc": "",
        "other": "住所 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea お客様相談室 +82-1600-0020(PCゲーム)、+82-1566-7004(モバイルゲーム)、FAX +82-2-2186-3550(PCゲーム)、+82-2-2186-3499(モバイルゲーム)",
        "none": '',
        "infoEmail": "Eメール",
        
        "infoEmail-mobile": "MobileCS@ncsoft.com",
        "infoEmail-pc": "credit@ncsoft.com",
        "infoEmail-other": "credit@ncsoft.com/(PCゲーム)/MobileCS@ncsoft.com/(モバイルゲーム)",
        "infoEmail-none": "",
    },
    infoJP:{
        "jpReleaseDayValue_LW": "2021年11月4日",
        "jpReleaseDay": "リリース日",
        "jpDevelopedBy": "開発/運営",
        "jpOs": "対応OS",
        "jpPriceValue": "基本無料 (アイテム課金あり)",
        "jpPrice": "価格",
        "jpGenre": "ジャンル",
        "jpTitle": "タイトル",
    },
    "country": {
        "HK": "香港",
        "PH": "フィリピン",
        "TH": "タイ",
        "QA": "カタール",
        "JP": "日本",
        "ID": "インドネシア",
        "AE": "アラブ首長国連邦",
        "SG": "シンガポール",
        "SA": "サウジアラビア",
        "MY": "マレーシア",
        "RU": "ロシア",
        "TW": "台湾",
        "KR": "大韓民国",
        "UA": "ウクライナ",
        "BY": "ベラルーシ",
        "LT": "リトアニア",
        "PL": "ポーランド",
        "GR": "ギリシャ",
        "IL": "イスラエル",
        "KW": "クウェート",
        "AT": "オーストリア",
        "US": "アメリカ",
        "CA": "カナダ",
        "DE": "ドイツ",
        "GB": "英国",
        "FR": "フランス",
        "BR": "ブラジル",
        "IT": "イタリア",
        "ES": "スペイン",
        "CL": "チリ",
        "NO": "ノルウェー",
        "SE": "スウェーデン",
        "IE": "アイルランド",
        "PT": "ポルトガル",
        "FI": "フィンランド",
        "DK": "デンマーク",
        "CH": "スイス",
        "AR": "アルゼンチン",
        "PE": "ペルー",
        "MX": "メキシコ",
        "KZ": "カザフスタン",
        "UZ": "ウズベキスタン",
        "AZ": "アゼルバイジャン",
        "GE": "ジョージア",
        "MD": "モルドバ",
        "AM": "アルメニア",
        "NC": "Global"
    }
};